var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-info",style:({ bottom: ((_vm.barHeight + 10) + "px") })},[(_vm.fileName)?_c('h1',{staticClass:"accent"},[_vm._v(_vm._s(_vm.fileName))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }